import { Bracket, GameId } from "@portal-frontend-ssr/blast-api";
import { TournamentSchedule } from "~/shared/components/TournamentSchedule";
import { mapBracketsToTournamentSchedule } from "~/shared/helpers/tournaments/mapBracketsToTournamentSchedule";
import { Broadcast } from "~/api/broadcasts/shared/schemas";

export const TournamentPageSchedule = ({
  gameId,
  brackets,
  liveBroadcasts,
  tournament,
}: {
  gameId: GameId;
  brackets: Bracket[];
  liveBroadcasts: Broadcast[];
  tournament: { name: string };
}) => {
  const { dates: tournamentScheduleDates } = mapBracketsToTournamentSchedule(brackets ?? []);

  return (
    <>
      <h2 className="font-style-label-l3">Schedule</h2>
      <TournamentSchedule
        dates={tournamentScheduleDates}
        broadcasts={liveBroadcasts}
        tournamentName={tournament.name}
        gameId={gameId}
      />
    </>
  );
};
